<div class="profil-management-header">
    <h2>Liste des rôles</h2>
    <div class="search-add">
        <div class="search-bar-container">
            <frg-search-input (search)="onSearch($event)"></frg-search-input>
        </div>
        <button (click)="navigateToCreateProfile()">
            <div class="svg-user-add"></div>
        </button>
    </div>
</div>
<div class="profil-management-body">
    <div class=profil-management-table>
        <!-- <div class="title">
            Liste des profils trouvés
        </div> -->
        <div class="table">
            <frg-table [keysColumn]="roleColumnTable" [keysBody]="rolesPaginated" tableButton1="/assets/icons/trash.svg"
                tableButton2="/assets/icons/edit.svg" (onClick1)="delete($event)" (onClick2)="edit($event)"
                (onChangePage)="onChangePage($event)" (onSort)="onSort($event)">
            </frg-table>
        </div>
    </div>
</div>